import { CurrencyOrEmpty } from '@plato/app-shared/components/currency-or-empty';
import { SrSalesOrderType } from '@plato/data/starrocks/types';
import { DateText } from '@plato/ui-legacy/components/common/date-time-text';
import type { ColumnDef } from '@plato/ui/components/data-table';
import { Typography } from '@plato/ui/primitives/typography';
import { Trans } from 'react-i18next';
import type { GetManyQuotesOrdersListItem } from '../../../server/types/infer-trpc-types.ts';
import { QuoteOrderIdentityCell } from '../components/quote-order-identity-cell.tsx';
import type { QuoteOrderSummaryData } from './use-quote-columns-for-list-grid.tsx';

type QuoteOrderMobileColumnId = 'mobile_transaction' | 'mobile_total';

type QuoteOrderColumnDef = ColumnDef<
    QuoteOrderMobileColumnId,
    GetManyQuotesOrdersListItem,
    QuoteOrderSummaryData
>;

function quoteOrderMobileColumns(type: SrSalesOrderType): readonly QuoteOrderColumnDef[] {
    return [
        {
            id: 'mobile_transaction',
            meta: {
                pinned: 'left',
                summary: () => <Trans ns="quotes-orders-list" i18nKey="table_footer__sum" />,
            },
            cell: ({ row }) => (
                <QuoteOrderIdentityCell
                    type={type}
                    transactionId={row.original.sales_order_id}
                    customerName={row.original.customer_name}
                    status={row.original.status}
                    statusType={row.original.type}
                />
            ),
        },
        {
            id: 'mobile_total',
            meta: {
                pinned: 'right',
                summary: (data) => (
                    <Typography variant="body" className="tabular-nums">
                        <CurrencyOrEmpty decimals={2}>{data.total_amount_net}</CurrencyOrEmpty>
                    </Typography>
                ),
            },
            cell: ({ row }) => (
                <div className="flex flex-col items-end">
                    <Typography variant="body" className="tabular-nums">
                        <CurrencyOrEmpty decimals={2}>{row.original.total_amount_net}</CurrencyOrEmpty>
                    </Typography>
                    <Typography variant="caption" className="text-content-weaker tabular-nums">
                        <DateText date={row.original.entry_date} />
                    </Typography>
                </div>
            ),
        },
    ];
}

export const orderMobileColumns = quoteOrderMobileColumns(SrSalesOrderType.ORDER);

export const quoteMobileColumns = quoteOrderMobileColumns(SrSalesOrderType.QUOTE);
